import { loadPropertyMedia, propertyMediaUrls } from './propertyMedia';

// A page-session cache shared by cards and galleries. A URL is trusted only after
// an image actually loads; a failed URL is not selected again on a React render.
const photos = new Map();
const MAX_FAILURES = 5;
const recordFor = key => {
  if (!photos.has(key)) photos.set(key, { good: '', failed: new Set(), candidates: [], listeners: new Set() });
  return photos.get(key);
};
const notify = record => record.listeners.forEach(listener => listener());
export const subscribeThumbnail = (key, listener) => {
  const record = recordFor(key);
  record.listeners.add(listener);
  return () => record.listeners.delete(listener);
};
export function thumbnailSource(key, initial) {
  const record = recordFor(key);
  if (record.good) return record.good;
  if (record.failed.size >= MAX_FAILURES) return '';
  return [initial, ...record.candidates].find(url => typeof url === 'string' && url.trim() && !record.failed.has(url)) || '';
}
export function rememberPropertyPhoto(key, url) {
  if (!key || !url) return;
  const record = recordFor(key);
  // Keep the first proven photo, rather than switching as every gallery photo loads.
  if (record.good) return;
  record.failed.delete(url);
  record.good = url;
  notify(record);
}
export function refreshThumbnail(key) {
  if (!key) return Promise.resolve();
  const record = recordFor(key);
  return loadPropertyMedia(key).then(media => {
    record.candidates = propertyMediaUrls(media);
    notify(record);
  });
}
export function rejectThumbnail(key, url, canRefresh = true) {
  const record = recordFor(key);
  if (url) record.failed.add(url);
  if (record.good === url) record.good = '';
  notify(record);
  if (canRefresh && record.failed.size < MAX_FAILURES) return refreshThumbnail(key);
  return Promise.resolve();
}
